import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import IUser from "Types/User";
import { State } from "store/reducers";

export const GET_USER = "[USER GET] GET_USER";
export const GET_USER_SUCCESS = "[USER GET] GET_USER_SUCCESS";
export const GET_USER_FAILED = "[USER GET] GET_USER_FAILED";

export const SET_VALUE = "[USER GET] SET_VALUE";
export const CLEAR_VALUES = "[USER GET] CLEAR_VALUES";

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getUser(id: string, callback?: Callback<IUser>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_USER });

		try {
			const { login } = getState() as State;

			const response = await api.sendGet("/User/" + id, {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_USER_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_USER_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			callback && callback(error);

			return dispatch({
				type: GET_USER_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
